import MdContainer, { type ContainerOpts } from 'markdown-it-container';
import type MdIt from 'markdown-it';

export const MdContainerOptions: ContainerOpts = {
	// marker: ':::',
	validate(params: string) {
		// console.log('validate', params);
		return !!params.trim().match(/^\s*collapse\s+(.*)$/);
	},
	render(
		tokens: MdIt.Token[],
		idx: number,
		opts: MdIt['options'],
		context: Record<string, unknown>,
		renderer: MdIt['renderer'],
	) {
		let token = tokens[idx];
		// console.log('render', tokens, idx);
		if (token.type === 'container_collapse_close') return '</div></details>';
		if (token.type !== 'container_collapse_open') return '';
		let header = token.info;
		let headerParsed = header?.match(/^\s*collapse\s+(.*)$/);
		if (!headerParsed) return '';
		let headerText = headerParsed[1];
		return `<details class="cms-details">
			<summary>${headerText}</summary>
			<div>`;
	},
};

export const MdSectionOptions: ContainerOpts = {
	validate(params: string) {
		return !!params.trim().match(/^\s*section\s*$/);
	},
	render(
		tokens: MdIt.Token[],
		idx: number,
		opts: MdIt['options'],
		context: Record<string, unknown>,
		renderer: MdIt['renderer'],
	) {
		let token = tokens[idx];
		// console.log('render1', token, idx, opts, context);
		if (token.type === 'container_section_close') return '</div>';
		if (token.type !== 'container_section_open') return '';
		return '<div class="cms-link-box">';
	},
};

export const MdTextBoxOptions: ContainerOpts = {
	// marker: ':::',
	validate(params: string) {
		// console.log('validate', params);
		return !!params.trim().match(/^\s*textbox\s*$/);
	},
	render(
		tokens: MdIt.Token[],
		idx: number,
		opts: MdIt['options'],
		context: Record<string, unknown>,
		renderer: MdIt['renderer'],
	) {
		const token = tokens[idx];
		if (token.type === 'container_textbox_open') {
			return `<div class="cms-text-box">\n`;
		}
		if (token.type === 'container_textbox_close') {
			return `</div>\n`;
		}
		return '';
	},
};

export const MdTextBoxLeftOptions: ContainerOpts = {
	// marker: ':::',
	validate(params: string) {
		// console.log('validate', params);
		return !!params.trim().match(/^\s*lefttextbox\s*$/);
	},
	render(
		tokens: MdIt.Token[],
		idx: number,
		opts: MdIt['options'],
		context: Record<string, unknown>,
		renderer: MdIt['renderer'],
	) {
		const token = tokens[idx];
		if (token.type === 'container_lefttextbox_open') {
			return `<div class="cms-left-text-box">\n`;
		}
		if (token.type === 'container_lefttextbox_close') {
			return `</div>\n`;
		}
		return '';
	},
};

export default function mdInlineUnderline(md: MdIt) {
	function tokenize(state: any) {
		const start = state.pos;
		const marker = ':::';
		if (state.src.startsWith(marker, start) === false) return false;
		const end = state.src.indexOf(marker, start + marker.length);
		if (end === -1) return false;
		const full = state.src.slice(start, end + 3);
		const inner = state.src.slice(start + 3, end).trim();
		if (!inner.startsWith('underline ')) return false;
		const text = inner.replace(/^underline\s*/, '');
		const tokenOpen = state.push('underline_open', 'span', 1);
		tokenOpen.attrSet('class', 'underline-text');
		const tokenText = state.push('text', '', 0);
		tokenText.content = text;
		state.push('underline_close', 'span', -1);
		state.pos = end + 3;
		return true;
	}
	md.inline.ruler.before('emphasis', 'inline_underline', tokenize);
	md.renderer.rules.underline_open = () => `<span class="underline-text">`;
	md.renderer.rules.underline_close = () => `</span>`;
}

export const plugins: MdIt.PluginWithOptions[] = [
	(instance: MdIt) => instance.use(MdContainer, 'collapse', MdContainerOptions),
	(instance: MdIt) => instance.use(MdContainer, 'section', MdSectionOptions),
	(instance: MdIt) => instance.use(MdContainer, 'textbox', MdTextBoxOptions),
	(instance: MdIt) => instance.use(MdContainer, 'lefttextbox', MdTextBoxLeftOptions),
	(instance: MdIt) => instance.use(mdInlineUnderline),
];
